module.exports = __webpack_public_path__ + "img/stickers-justificatif-dettes.d766e088.jpg";